














import { Component, Vue } from 'vue-property-decorator'
import NotificationsListState from '../../notifications-list-state.vue'

@Component({
  name: 'notifications-list-empty',
  components: {
    NotificationsListState,
  },
})
export default class NotificationsListEmptyComponent extends Vue {}
